// import React, { useState } from 'react';

// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
// import { Form as FinalForm } from 'react-final-form';

// import EmailTemplateForm from 'components/EmailTemplateForm/EmailTemplateForm';

// import {
//     actions,
// } from 'coupon-common/src/modules/admin/emailManager';

// const CreateEmailTemplate = ({
//     dispatch,
//     initialValues,
//     onPreview,
//     onCreated,
//     styles,
// }) => {
//     const [submitting, setSubmitting] =
//         useState(false);

//     const handleCreate = values => {
//         const payload = {
//             name: values.name,
//             subject: values.subject,
//             body: values.body,
//             enabled: values.enabled,
//             transactional: values.transactional,
//         };

//         setSubmitting(true);

//         dispatch(
//             actions.createEmailTemplate(
//                 payload,
//                 result => {
//                     setSubmitting(false);

//                     if (result?.success) {
//                         onCreated();
//                     } else {
//                         alert("There was an error creating the template")
//                         // console.error(
//                         //     'Failed to create email template:',
//                         //     result?.error
//                         // );
//                     }
//                 }
//             )
//         );
//     };

//     return (
//         <div className={styles.editor}>
//             <h4>Create New Email Template</h4>

//             <FinalForm
//                 initialValues={initialValues}
//                 onSubmit={handleCreate}
//                 render={({
//                     handleSubmit,
//                     values,
//                 }) => (
//                     <form onSubmit={handleSubmit}>
//                         <EmailTemplateForm
//                             values={values}
//                             onPreview={onPreview}
//                             isEdit={false}
//                             isBaseTemplate={false}
//                             submitLabel="Create Template"
//                             submitting={submitting}
//                         />
//                     </form>
//                 )}
//             />
//         </div>
//     );
// };

// CreateEmailTemplate.propTypes = {
//     dispatch: PropTypes.func.isRequired,
//     initialValues: PropTypes.object.isRequired,
//     onPreview: PropTypes.func.isRequired,
//     onCreated: PropTypes.func.isRequired,
//     styles: PropTypes.object.isRequired,
// };

// export default connect()(CreateEmailTemplate);

import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';

import EmailTemplateForm from 'components/EmailTemplateForm/EmailTemplateForm';

import {
    actions,
} from 'coupon-common/src/modules/admin/emailManager';

const CreateEmailTemplate = ({
    dispatch,
    initialValues,
    onPreview,
    onSendTestEmail,
    onCreated,
    styles,
}) => {
    const [submitting, setSubmitting] =
        useState(false);

    const handleCreate = values => {
        const payload = {
            name: values.name,
            subject: values.subject,
            body: values.body,
            enabled: values.enabled,
            transactional: values.transactional,
        };

        setSubmitting(true);

        dispatch(
            actions.createEmailTemplate(
                payload,
                result => {
                    setSubmitting(false);

                    if (result?.success) {
                        alert('Template created successfully');
                        onCreated();
                    } else {
                        alert("There was an error creatingthe template.")
                        // console.error(
                        //     'Failed to create email template:',
                        //     result?.error
                        // );
                    }
                }
            )
        );
    };

    return (
        <div className={styles.editor}>
            <h4>Create New Email Template</h4>

            <FinalForm
                initialValues={initialValues}
                onSubmit={handleCreate}
                render={({
                    handleSubmit,
                    values,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <EmailTemplateForm
                            values={values}
                            onPreview={onPreview}
                            onSendTestEmail={
                                onSendTestEmail
                            }
                            isEdit={false}
                            isBaseTemplate={false}
                            submitLabel="Create Template"
                            submitting={submitting}
                        />
                    </form>
                )}
            />
        </div>
    );
};

CreateEmailTemplate.propTypes = {
    dispatch: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    onPreview: PropTypes.func.isRequired,
    onSendTestEmail: PropTypes.func.isRequired,
    onCreated: PropTypes.func.isRequired,
    styles: PropTypes.object.isRequired,
};

export default connect()(CreateEmailTemplate);